/**
 * CadastroRapidoFornecedorDialog - Modal de cadastro rápido de fornecedor (extraído de Compras.jsx).
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Users, Plus } from 'lucide-react';

const CadastroRapidoFornecedorDialog = ({ open, onOpenChange, form, setForm, onSave }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Users className="w-5 h-5" />
            Cadastrar Fornecedor
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <div>
            <Label>Nome/Razão Social *</Label>
            <Input
              value={form.nome}
              onChange={(e) => setForm(prev => ({ ...prev, nome: e.target.value }))}
              placeholder="Nome completo do fornecedor"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>CNPJ</Label>
              <Input
                value={form.cnpj}
                onChange={(e) => setForm(prev => ({ ...prev, cnpj: e.target.value }))}
                placeholder="00.000.000/0000-00"
              />
            </div>
            <div>
              <Label>Telefone</Label>
              <Input
                value={form.telefone}
                onChange={(e) => setForm(prev => ({ ...prev, telefone: e.target.value }))}
                placeholder="(00) 00000-0000"
              />
            </div>
          </div>

          <div>
            <Label>E-mail</Label>
            <Input
              type="email"
              value={form.email}
              onChange={(e) => setForm(prev => ({ ...prev, email: e.target.value }))}
              placeholder="contato@fornecedor.com"
            />
          </div>

          <div>
            <Label>Nome do Contato</Label>
            <Input
              value={form.contato_nome}
              onChange={(e) => setForm(prev => ({ ...prev, contato_nome: e.target.value }))}
              placeholder="Nome da pessoa de contato"
            />
          </div>
        </div>

        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={onSave}>
            <Plus className="w-4 h-4 mr-1" />
            Cadastrar Fornecedor
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CadastroRapidoFornecedorDialog;
